module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/is-pure.js
// module id = 162
// module chunks = 1 2 3 4